import React from "react";
import { Radio, Typography } from "antd";
import { FormattedMessage } from "react-intl";
const { Title } = Typography;

const EventDaySelector = (props) => {
  const { onEventDayChange, activeEvent } = props;

  const options = [
    { value: 0, label: "א" },
    { value: 1, label: "ב" },
    { value: 2, label: "ג" },
    { value: 3, label: "ד" },
    { value: 4, label: "ה" },
    { value: 5, label: "ו" },
    { value: 6, label: "ש" },
  ];

  return (
    <div>
      <Title level={5}>
        {<FormattedMessage id="app.plans.PlanEventDayTitle" />}
      </Title>
      <Radio.Group
        options={options}
        value={activeEvent.weekday}
        onChange={(e) => onEventDayChange(e.target.value)}
      />
    </div>
  );
};

export default EventDaySelector;
